import { Component, OnInit } from '@angular/core';

import { UntypedFormControl, Validators } from '@angular/forms';

import {
  EnableClassTelemetry,
  EnableComponentTelemetry,
  injectComponentTelemetryService,
} from 'app/services/otel.service';
import { SemantriaConfiguration } from '../../providers/semantria-api/configuration.service';
import { LexTableAction, LexTableColumn } from './lex-table/lex-table.component';

@EnableClassTelemetry()
@Component({
  selector: 'app-uikit',
  templateUrl: './uikit.component.html',
  styleUrls: ['./uikit.component.scss'],
  standalone: false,
})
export class UikitComponent implements OnInit {
  @EnableComponentTelemetry() otelService = injectComponentTelemetryService();
  buttons = [
    {
      type: 'big',
      title: 'Big button - 60px',
      colors: ['green'],
      spinner: {
        size: 35,
        width: 4,
      },
    },
    {
      type: 'normal',
      title: 'Normal button - 48px',
      colors: ['green', 'blue', 'white'],
      spinner: {
        size: 25,
        width: 3,
      },
    },
    {
      type: 'small',
      title: 'Small button - 24px',
      colors: ['green', 'blue', 'white'],
      spinner: {
        size: 15,
        width: 2,
      },
    },
  ];

  selectOptions = [
    { label: 'Placeholder' },
    { label: 'Filled' },
    { label: 'Active' },
    { label: 'Selectable item 001' },
    { label: 'Selectable item 002' },
    { label: 'Selectable item 003' },
  ];

  errorControl = new UntypedFormControl('', [
    Validators.required,
    Validators.minLength(Number.MAX_SAFE_INTEGER),
  ]);
  activeControl = new UntypedFormControl('');
  selectControl = new UntypedFormControl(this.selectOptions[2]);

  config: SemantriaConfiguration;
  selectedConfig: SemantriaConfiguration;

  project: any;

  tableColumns: LexTableColumn[] = [
    { id: 'name', label: 'Name' },
    { id: 'tags', label: 'Tags' },
    { id: 'createdBy', label: 'Created By' },
    { id: 'lastUsed', label: 'Last Used' },
  ];

  tableActions: LexTableAction[] = [
    { icon: 'download', action: ($event) => console.log($event) },
    { icon: 'content_copy', action: ($event) => console.log($event) },
  ];

  denseTableColumns: LexTableColumn[] = [
    { id: 'name-dense', label: 'Name' },
    { id: 'lastUsed-dense', label: 'Last Used' },
    { id: 'link-dense', label: '' },
  ];

  codeContent: string;

  constructor() {
    this.config = {
      id: 'asdfggh213214124',
      group: 'testgroup',
      name: 'Reddit Liquor',
      creator_user_id: 'API',
      settings: [],
      language_id: 'en',
      language_name: 'English',
      creation_date: new Date(),
      modification_date: new Date(),
      last_processing_date: new Date(),
      alphanumeric_threshold: 5,
      concept_topics_threshold: 3.65,
      entities_threshold: 5,
      summary_size: 5,
      is_autoresponse_enabled: false,
      tags: ['Reddit', 'Demo', 'Microsoft'],
      removed: false,
      config_routes: [
        {
          config_route_id: 'cr9090909',
          config_route_name: 'Product CR',
        },
      ],
    };

    this.project = {
      name: 'Project name',
      updated: new Date(),
    };

    this.codeContent =
      'import {ViewPlugin} from "@codemirror/view"\n' +
      '\n' +
      'const docSizePlugin = ViewPlugin.fromClass(class {\n' +
      '  constructor(view) {\n' +
      '    this.dom = view.dom.appendChild(document.createElement("div"))\n' +
      '    this.dom.style.cssText =\n' +
      '      "position: absolute; inset-block-start: 2px; inset-inline-end: 5px"\n' +
      '    this.dom.textContent = view.state.doc.length\n' +
      '  }\n' +
      '\n' +
      '  update(update) {\n' +
      '    if (update.docChanged)\n' +
      '      this.dom.textContent = update.state.doc.length\n' +
      '  }\n' +
      '\n' +
      '  destroy() { this.dom.remove() }\n' +
      '})';
  }

  ngOnInit() {
    this.errorControl.markAsDirty();
    this.errorControl.updateValueAndValidity();
  }

  toggleSelectedConfiguration(conf) {
    if (this.selectedConfig) {
      this.selectedConfig = undefined;
    } else {
      this.selectedConfig = conf;
    }
  }
}
